import { useState } from 'react';
import { SortType } from '../../components/ProductGridCoCo/ProductGridSortCoCo.js';
import { createDeviceSelectionFilters, getVisibleDevices } from '../utils/deviceSelectionDeviceUtilsCoCo.js';
import type { DeviceSelectionDeviceCoCo, DeviceSelectionFiltersCoCo } from '../utils/deviceSelectionDeviceUtilsCoCo.js';

const NO_SELECTED_FIRST_IDS: ReadonlySet<string> = new Set();

export const useDeviceListControlsCoCo = (
  devices: DeviceSelectionDeviceCoCo[],
  selectedFirstIds: ReadonlySet<string> = NO_SELECTED_FIRST_IDS
) => {
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState(SortType.ORDER_NEWEST);
  const [filterSelections, setFilterSelections] = useState<DeviceSelectionFiltersCoCo>();
  const filters = createDeviceSelectionFilters(devices, filterSelections);
  const visibleDevices = getVisibleDevices(devices, { search, filters, sort, selectedFirstIds });

  return {
    filters,
    search,
    setFilters: setFilterSelections,
    setSearch,
    setSort,
    sort,
    visibleDevices,
  };
};
